/* eslint-disable */
import React from 'react';

export default class ChatComposer extends React.Component {
  constructor(props) {
    super(props);
    this.state = { text: '' };
  }

  _onChange = (e) => {
    this.setState({ text: e.target.value });
  };

  _onKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      this._send();
    }
  };

  _onFormSubmit = (e) => {
    e.preventDefault();
    this._send();
  };

  _send = () => {
    const text = this.state.text.trim();
    if (!text) return;
    this.props.onSend(text);
    this.setState({ text: '' });
  };

  render() {
    return (
      <div style={{ width: '100%' }}>
        <form onSubmit={this._onFormSubmit}>
          <textarea
            className='input-text'
            placeholder="say or type the definition"
            autoComplete='off'
            onChange={this._onChange}
            value={this.state.text}
            onKeyDown={this._onKeyDown}
            style={{
              height: '80px',
              resize: 'vertical',
              wordWrap: 'break-word',
              whiteSpace: 'pre-wrap'
            }}
          />
          <button type="submit" className='btn btn-outline-secondary' style={{ marginLeft: 0, marginTop: 20 }}>Send</button>
        </form>
      </div>
    );
  }
} 


// WEBPACK FOOTER //
// ./src/components/tack_ai_chat/chat_composer.jsx